/*
  gsb-new-builder-nudge.js

  Shows the Ninja Builder / Legacy Builder tab strip across the top of the
  OLD gang sheet builder overlay. Legacy Builder is the current tab; Ninja
  Builder links to the new builder.
  Markup: snippets/gsb-new-builder-nudge.liquid. Styles: the matching .css.
  Rendered only on the DTF and UV gang sheet PDPs.

  This replaced the "try the new builder" announcement bar in place, which
  is why the file and ids still say "nudge". The
  strip is not dismissible. Like the bar it is dark, so it fades in from white
  on first open rather than snapping in dark over the builder's white loading
  screen (the CSS does the fade; settleAfterFirstFade() stops it replaying).

  HOW THE OLD BUILDER BEHAVES (verified against the live PDP - do not assume
  otherwise, the app is third-party and none of this is in the theme):

    - #gs-builder-modal is created LAZILY on first open and appended to
      <html>, NOT to <body>. A body margin therefore cannot move it.
    - Its content is a CROSS-ORIGIN iframe (app.dripappsserver.com), so
      nothing can be injected inside the builder itself. The bar has to live
      in the parent document and the overlay has to be shrunk to make room.
    - Close does NOT remove the element - the app just sets
      `style.display = 'none'` and leaves it in the DOM. So visibility has to
      track the COMPUTED DISPLAY, not the element's existence.
    - The iframe is sized to 100% of the overlay, so clamping the overlay
      height reflows the builder's own header/canvas into the smaller
      viewport rather than clipping it.

  Everything visual hangs off a single `nt-gsb-nudge-on` class on <html>, so
  hiding the strip restores the overlay's original geometry with no inline
  styles to unwind.
*/
(function () {
  if (window.__ntGsbNudge) return;
  window.__ntGsbNudge = true;

  try {
    var MODAL_ID = 'gs-builder-modal';
    var ON_CLASS = 'nt-gsb-nudge-on';

    var bar = document.getElementById('nt-gsb-nudge');
    if (!bar) return;

    var root = document.documentElement;
    var impressionSent = false;
    var modalObserver = null;
    var leaveTimer = null;

    /* position:fixed resolves against the nearest transformed ancestor, not
       the viewport. Reparenting to <body> (verified to have no transformed
       ancestors) keeps the bar flush to the top regardless of what the
       product section around the render point does. */
    if (bar.parentNode !== document.body) document.body.appendChild(bar);

    /* THE OLD BUILDER GUARDS THE PARENT PAGE WITH ITS OWN beforeunload, so
       clicking our CTA raised Chrome's "Leave site? / Changes you made may
       not be saved." on an ordinary same-site navigation the shopper had
       just asked for. The moment the overlay opens, the app's
       gang-edit.min.js runs this - verified on the live PDP, in the PARENT
       window, not inside the builder iframe:

         window.addEventListener('beforeunload', function (e) {
           var t = "Are you sure you want to leave?";
           return e.returnValue = t, t;
         });

       Chrome ignores the custom text and shows its own generic wording,
       which is exactly what the shopper was seeing. The listener is
       anonymous and belongs to a third-party app bundle, so there is no
       reference to hand to removeEventListener.

       ⚠ DO NOT "SIMPLIFY" THIS TO stopImmediatePropagation(). That was the
       first cut and it was wrong. This page already carries FOUR other
       beforeunload listeners registered during page load - Rebuy's analytics
       flush (`drain({keepalive:true})`), the Yotpo pixel's unload plugin, a
       session-timing tracker, and one obfuscated capture-phase handler - and
       our script runs EARLY, after only the first of them. Cutting the chain
       there would have silently dropped their unload work on every Try It
       click, including analytics for the very click-through this bar exists
       to measure.

       So clear the prompt request instead of blocking anyone. It is enough:
       the app's handler only SETS returnValue and never calls
       preventDefault, and a listener's return value is ignored for
       addEventListener (only the legacy onbeforeunload property honours it).
       Everyone else's handler still runs, in order, untouched. */
    function allowLeave(e) {
      e.returnValue = '';
    }

    /* Registered at CLICK time, on purpose: that puts us LAST in line, after
       every other listener including the builder's own (registered back when
       the overlay opened), so we only wipe the prompt once they have all had
       their turn. Registering at init would have put us near the front,
       which is the bug described above. */
    function armLeave() {
      window.addEventListener('beforeunload', allowLeave);
      if (leaveTimer) clearTimeout(leaveTimer);
      /* Safety net. If the navigation never actually happens - blocked, a
         download-type response, a Back that restores this page from bfcache
         - put the builder's guard back rather than leaving it off for the
         rest of the visit. */
      leaveTimer = setTimeout(disarmLeave, 5000);
    }

    function disarmLeave() {
      window.removeEventListener('beforeunload', allowLeave);
      if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
    }

    /* A Back out of the new builder can restore this page from bfcache with
       the pass still armed; drop it immediately rather than waiting out the
       timer. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) disarmLeave(); });

    /* GA4 events, the countable record of the strip (they reach the BigQuery
       export). `builder` says which old builder (dtf | uv); `link` says which
       new-builder link was clicked (tab | subtext). Clicks go by beacon so
       the event survives the navigation it starts. The GA4 page-path
       derivation (old-builder path then /apps/ninja-gang-sheet in one
       session) stays the backstop - it cannot be lost to a cancelled send.
       Deliberately NOT utm_* params on the link: a utm on an internal
       navigation makes GA4 start a NEW session, which would sever the click
       from the old-builder session being measured. (The Optimizely pushes
       gsb_nudge_impression / _click that used to sit beside these were never
       defined in the Optimizely project, so were always dropped; removed
       with the experiment.) */
    var BUILDER = bar.getAttribute('data-nt-builder') || 'dtf';
    function gaEvent(name, params) {
      try {
        if (typeof window.gtag !== 'function') return;
        window.gtag('event', name, params);
      } catch (e) { /* noop */ }
    }

    /* Make the new builder this shopper's builder from now on: the product
       page shows its button instead of the old builder's (read by
       snippets/optimizely-gang-sheet-experiment.liquid). Without this, a
       shopper whose default is legacy - by an earlier tab click, or by the
       customer tag - would be handed the old builder again next visit. The
       new builder's Legacy Builder tab writes "legacy" the same way, so the
       last builder picked is always the one served next. Per browser.

       Key and values are shared with that snippet and with the new builder
       (ninja-gangsheet-builder repo, BUILDER_DEFAULT_KEY in
       src/lib/oldBuilderSwitchBack.ts) - keep all three in step. */
    function chooseNewBuilder() {
      try { window.localStorage.setItem('ninja_builder_default', 'new'); }
      catch (e) { /* storage blocked - the shopper just gets the default next time */ }
    }

    function getModal() { return document.getElementById(MODAL_ID); }

    function isOpen(m) {
      if (!m) return false;
      try { return window.getComputedStyle(m).display !== 'none'; }
      catch (e) { return false; }
    }

    function watchModal() {
      var m = getModal();
      if (!m || modalObserver) return;
      /* The app toggles the overlay via its inline style attribute. Our own
         show/hide only touches a class on <html>, which changes the overlay's
         computed style but not its attributes - so this cannot re-trigger
         itself. */
      modalObserver = new MutationObserver(sync);
      modalObserver.observe(m, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    /* Counted on the first open per page view, not on every reopen. */
    function countImpression() {
      if (impressionSent) return;
      impressionSent = true;
      gaEvent('gsb_tabs_impression', { builder: BUILDER });
    }

    /* The CSS fades the strip in from white on first open (see the .css for
       why). Once that has played, mark it settled so a reopen shows the strip
       straight away. 900ms = the CSS's .25s delay + .5s fade, plus slack. */
    var SETTLED_CLASS = 'nt-gsb-nudge--settled';
    var settleTimer = null;
    function settleAfterFirstFade() {
      if (settleTimer || bar.classList.contains(SETTLED_CLASS)) return;
      settleTimer = setTimeout(function () { bar.classList.add(SETTLED_CLASS); }, 900);
    }

    function sync() {
      watchModal();
      if (isOpen(getModal())) {
        root.classList.add(ON_CLASS);
        countImpression();
        settleAfterFirstFade();
      } else {
        root.classList.remove(ON_CLASS);
      }
    }

    /* The overlay does not exist until the shopper opens the builder, so
       watch <html> for it being appended, then hand off to watchModal(). */
    new MutationObserver(sync).observe(root, { childList: true });

    /* Every link to the new builder: the Ninja Builder tab and the "new
       Ninja Builder" link in the subtext. One GA4 event, told apart by
       `link`. */
    var ctas = Array.prototype.slice.call(bar.querySelectorAll('[data-nt-nudge-cta]'));
    function linkOf(cta) { return cta.getAttribute('data-nt-link') || 'tab'; }

    function goToNewBuilder(cta, newTab) {
      gaEvent('gsb_tabs_click', {
        builder: BUILDER,
        link: linkOf(cta),
        transport_type: 'beacon'
      });
      chooseNewBuilder();
      /* A new tab leaves this page, and its work, where they are; the browser
         opens it from the href. Arming the beforeunload pass there would
         disarm the builder's guard for the rest of the visit. */
      if (newTab) return;
      armLeave();
      window.location.href = cta.href;
    }

    ctas.forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        if (e.defaultPrevented) return;
        /* A modified or middle click opens a new tab: nothing here is lost,
           so no warning. */
        if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
          goToNewBuilder(cta, true);
          return;
        }
        /* A plain click leaves this builder. We cannot see inside it (a
           cross-origin iframe), so there is no way to tell whether the sheet
           has work on it - the warning shows on every switch, empty sheet
           included. Agreed with Matt 2026-09-24 as the only reliable option. */
        e.preventDefault();
        confirmSwitch(cta);
      });
    });

    /* The switch warning. Built on first use and reused. Sits above the strip
       (10000000) and the builder overlay (9999999). Focus goes to the box, not
       to Stay, so no button opens wearing a focus ring; Escape keeps the
       shopper's work where it is and Tab reaches the buttons. */
    var SWITCH_WARNING = {
      title: 'Leave the legacy builder?',
      /* Saving keeps the sheet in THIS builder; nothing ever moves to the
         Ninja Builder. Keep the copy from implying otherwise. */
      body: 'If you\u2019ve started a gang sheet, save it here first so you can come back to it later.',
      stay: 'Stay',
      switchLabel: 'Switch anyway'
    };
    var confirmEl = null;
    var confirmCta = null;
    var confirmReturnFocus = null;

    function buildConfirm() {
      var el = document.createElement('div');
      el.className = 'nt-gsb-confirm';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-labelledby', 'nt-gsb-confirm-title');
      el.setAttribute('aria-describedby', 'nt-gsb-confirm-body');
      el.innerHTML =
        '<div class="nt-gsb-confirm__box" tabindex="-1">' +
          '<h2 class="nt-gsb-confirm__title" id="nt-gsb-confirm-title"></h2>' +
          '<p class="nt-gsb-confirm__body" id="nt-gsb-confirm-body"></p>' +
          '<div class="nt-gsb-confirm__actions">' +
            '<button type="button" class="nt-gsb-confirm__btn" data-nt-confirm="stay"></button>' +
            '<button type="button" class="nt-gsb-confirm__btn nt-gsb-confirm__btn--primary" data-nt-confirm="switch"></button>' +
          '</div>' +
        '</div>';
      el.querySelector('#nt-gsb-confirm-title').textContent = SWITCH_WARNING.title;
      el.querySelector('#nt-gsb-confirm-body').textContent = SWITCH_WARNING.body;
      el.querySelector('[data-nt-confirm="stay"]').textContent = SWITCH_WARNING.stay;
      el.querySelector('[data-nt-confirm="switch"]').textContent = SWITCH_WARNING.switchLabel;

      el.addEventListener('click', function (e) {
        var action = e.target && e.target.getAttribute && e.target.getAttribute('data-nt-confirm');
        if (action === 'switch') { answerConfirm('switch'); return; }
        /* Stay, or a click on the dimmed backdrop outside the box. */
        if (action === 'stay' || e.target === el) answerConfirm('stay');
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); answerConfirm('stay'); return; }
        if (e.key !== 'Tab') return;
        /* Keep focus inside the dialog. */
        var buttons = el.querySelectorAll('button');
        var first = buttons[0];
        var last = buttons[buttons.length - 1];
        var onBox = !el.contains(document.activeElement) || document.activeElement === el.querySelector('.nt-gsb-confirm__box');
        if (e.shiftKey && (document.activeElement === first || onBox)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last)) { e.preventDefault(); first.focus(); }
      });
      document.body.appendChild(el);
      return el;
    }

    function confirmSwitch(cta) {
      if (!confirmEl) confirmEl = buildConfirm();
      confirmCta = cta;
      confirmReturnFocus = document.activeElement;
      root.classList.add('nt-gsb-confirm-on');
      confirmEl.querySelector('.nt-gsb-confirm__box').focus();
    }

    function answerConfirm(action) {
      var cta = confirmCta;
      confirmCta = null;
      root.classList.remove('nt-gsb-confirm-on');
      gaEvent('gsb_switch_warning', {
        builder: BUILDER,
        link: cta ? linkOf(cta) : 'tab',
        action: action
      });
      if (action === 'switch' && cta) { goToNewBuilder(cta, false); return; }
      if (confirmReturnFocus && confirmReturnFocus.focus) confirmReturnFocus.focus();
    }

    /* Keep the CTA pointed at whatever variant is currently selected on the
       PDP, so the new builder resolves the same size + transfer type the
       shopper was already looking at. VARIANT_CHANGE is dispatched
       non-bubbling on <product-variants>, so listen in the capture phase -
       same approach as assets/new-gang-sheet-cta.js. */
    var base = bar.getAttribute('data-nt-nudge-base') || '/apps/ninja-gang-sheet';
    document.addEventListener('VARIANT_CHANGE', function (e) {
      var el = e.target;
      if (!el || !el.currentVariant || !el.currentVariant.id) return;
      var href = base + '?ref=old-builder&variant=' +
        encodeURIComponent(el.currentVariant.id);
      ctas.forEach(function (cta) { cta.href = href; });
    }, true);

    /* Arriving from the new builder's "Legacy Builder" tab, which tags the
       URL ?ref=new-builder: open the old builder straight away rather than
       leaving the shopper on the product page to find the button again.

       The app only reads `variant` from the URL (checked in its
       main-product / gang-edit bundles), so there is no app-side way to do
       this - we click #gs-builder-btn for the shopper. The app attaches its
       handler to that button some time after load and a click before then
       does nothing, so retry until the overlay exists. Stop as soon as it
       does: the overlay is created on first open and never removed, and a
       second click while it is loading could re-trigger the app.

       layout/theme.liquid covers the product page with a loading screen
       (html.nt-gsb-opening) until then, so the shopper does not see the
       product page first. Lift it once the overlay is actually showing, not
       merely added to the page (it sits above the screen, so nothing
       flashes), or when we give up. Giving up here is the normal way out;
       the head script's own timer only covers this file failing to load. */
    (function openIfArrivingFromNewBuilder() {
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
      if (params.get('ref') !== 'new-builder') return;

      var OPENING_CLASS = 'nt-gsb-opening';
      var openingObserver = null;
      function stopLoadingScreen() {
        root.classList.remove(OPENING_CLASS);
        if (openingObserver) { openingObserver.disconnect(); openingObserver = null; }
      }
      // Watch <html> for the overlay being added, then the overlay itself for
      // the app showing it (it toggles its inline style).
      var watchingModal = false;
      function checkOpening() {
        var m = getModal();
        if (isOpen(m)) { stopLoadingScreen(); return; }
        if (m && !watchingModal && openingObserver) {
          watchingModal = true;
          openingObserver.observe(m, { attributes: true, attributeFilter: ['style', 'class'] });
        }
      }
      if (root.classList.contains(OPENING_CLASS)) {
        try {
          openingObserver = new MutationObserver(checkOpening);
          openingObserver.observe(root, { childList: true });
        } catch (e) { /* the timed checks below still lift it */ }
      }

      // Drop the tag so a refresh or a shared link is not a fresh arrival.
      params.delete('ref');
      try {
        var qs = params.toString();
        history.replaceState(history.state, '',
          location.pathname + (qs ? '?' + qs : '') + location.hash);
      } catch (e) {}

      var RETRY_MS = 700;
      var MAX_TRIES = 20; // ~14s, well past the app's usual attach time
      var tries = 0;
      function attempt() {
        if (isOpen(getModal()) || tries++ >= MAX_TRIES) { stopLoadingScreen(); return; }
        // Only click until the overlay exists; after that, just wait for it
        // to show (see above for why a second click is unsafe).
        if (!getModal()) {
          var btn = document.getElementById('gs-builder-btn');
          if (btn) btn.click();
        }
        setTimeout(attempt, RETRY_MS);
      }
      if (document.readyState === 'complete') attempt();
      else window.addEventListener('load', attempt, { once: true });
    })();

    sync();
  } catch (e) { /* never let the strip break the builder */ }
})();
